import { cn } from "@shared/utils";

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: React.ReactNode;
  className?: string;
}

/**
 * Checkbox atom.
 * 24px box with primary-110 checked state.
 */
export function Checkbox({
  checked,
  onChange,
  label,
  className,
}: CheckboxProps) {
  return (
    <label className={cn("flex items-start gap-3 cursor-pointer", className)}>
      <div
        className={cn(
          "flex h-6 w-6 flex-shrink-0 items-center justify-center rounded border-2 transition-colors mt-0.5",
          checked
            ? "bg-primary-110 border-primary-110"
            : "bg-white border-primary-110",
        )}
        onClick={() => onChange(!checked)}
      >
        {checked && (
          <svg width="14" height="10" viewBox="0 0 14 10" fill="none">
            <path
              d="M1 5L5 9L13 1"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>
      <span
        className="text-body text-black leading-snug"
        style={{ fontSize: 14 }}
      >
        {label}
      </span>
    </label>
  );
}
